export class Slide {
    id: number;
    title: string;
    slide: string;
    link: string;
    active: number;
    position: number;
    filetype: string;
    constructor(slide?) {
        if (slide) {
            this.id = slide.id || null;
            this.title = slide.url || null;
            this.slide = slide.owner_id || null;
            this.link = slide.created_at || null;
            this.active = slide.updated_at || 0;
            this.position = slide.type || 999;
            this.filetype = null;
        }
    }
}
